import { useEffect, useState } from "react";
import { RenderIf } from "../../../components";
import { ParseAndFormatUtcDateTime } from "../../../Utils";
import ReactPagination from "../../../components/common/Pagination";
import useSortableData from "../../../components/customHook/SortableTable";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { Dialog } from "../../../components";
import { useDispatch, useSelector } from 'react-redux';
import { isCaseSaved } from "../../../redux/actions/liabilty";
import Constants from '../../../Constants';
import '../style.css';
import { setUser } from "../../../redux/actions/users";
import { toaster } from "../../../utils/toast";
import { useDownloadDemandDraft } from "../../../hooks/useDownloadDemandDraft";
import { debounce } from "../../../utils/helper";
import useAxios from "../../../hooks/useAxios";
import XLoader from "../../../components/common/XLoader";
import XMultiSelect from "../../../components/common/XMultiSelect";
import { CASE_TYPE, DEMAND } from "../../../utils/enum";
import { ReactComponent as CopyIcon } from '../../../assets/icons/CopyIcon.svg';
import { ReactComponent as TaskComplete } from '../../../assets/icons/TaskComplete.svg';
import { ReactComponent as CloseCircle } from '../../../assets/icons/CloseCircle.svg';
import { CaseActionControls } from "../../../components";
import {
   Table,
   TableHead,
   TableBody,
   TableRow,
   TableCell,
   TableContainer,
   Paper,
   LinearProgress,
   Box,
   Popover,
} from "@mui/material";
import moment from "moment";
import AddCaseButton from "../../../components/ui-control/AddCaseButton";
import { offSocketEvent, onSocketEvent } from "../../../services/SocketService";

const Cases = () => {
   const [skeletonLoader, setSkeletonLoader] = useState({
      isActive: false,
      count: 10
   });
   const dispatch = useDispatch();
   const [casesList, setCasesList] = useState([]);
   const location = useLocation();
   const { items } = useSortableData(casesList);
   const [currentPage, setCurrentPage] = useState(1);
   const [totalCount, settotalCount] = useState("");
   const [totalPages, settotalPages] = useState(0);
   const [searchText, setsearchText] = useState("")
   const [showEntries, setshowEntries] = useState(10)
   const navigate = useNavigate();
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [isDeleteCaseModalOpen, setIsDeleteCaseModalOpen] = useState(false)
   const [isMyCases, setIsMyCases] = useState(false)
   const [errorLogData, setErrorLogData] = useState([]);
   const [caseId, setCaseId] = useState('');
   const [typeOfDemandDraft, setTypeOfDemandDraft] = useState('');
   const [selectedTeamValues, setSelectedTeamValues] = useState([]);
   const { subscription, teams } = useSelector((state) => state.users || {});
   const [currentTarget, setCurrentTarget] = useState(null)
   const [anchorEl, setAnchorEl] = useState(null);
   const { postData, deleteData } = useAxios()
  
   const downloadDemandDraft = useDownloadDemandDraft();
   const { getData, isLoading: getCaseIsLoading } = useAxios();
   const toggleSkeletonLoader = (value, count = 10) => {
      setSkeletonLoader((prevalue) => {
         return {
            ...prevalue,
            isActive: value,
            count
         }
      });
   };

   useEffect(() => {
      if (!skeletonLoader?.isActive) {
         toggleSkeletonLoader(true)
         getCases().then(() => { console.log("Case is loaded") });
      }
      console.log(process.env.REACT_APP_API_BASE_URL)
   }, [currentPage, searchText, showEntries, location.search, selectedTeamValues.length, isMyCases]) //items

   useEffect(() => {
    const handleToaster = (data) => {
      toaster(data);
    };

    const handleCaseUpdates = (data) => {
      setCasesList((prev) => {
        const updated = [...prev];
        const index = updated.findIndex((item) => item._id === data?.caseId);
        if (index !== -1) {
          updated[index] = { ...updated[index], ...data };
        }
        return updated;
      });
    };

    onSocketEvent('toaster', handleToaster);
    onSocketEvent('caseUpdates', handleCaseUpdates);

    return () => {
      offSocketEvent('toaster', handleToaster);
      offSocketEvent('caseUpdates', handleCaseUpdates);
    };
  }, [setCasesList]);

   const getCases = async () => {
      const url = `${Constants.ApiUrl.case.getCases}?pageNumber=${currentPage}&limit=${showEntries}&searchText=${searchText}&teamIds=${selectedTeamValues}&isMyCases=${isMyCases}`
      const resp = await getData(url);
      const { success } = resp
      if (success) {
         const { cases, totalCount, totalPages, subscription, userDetail } = resp.data
         const optionsTeams = userDetail?.teams?.map((team) => ({ key: team._id, text: team.name, value: team._id }))

         setCasesList(cases);
         settotalPages(totalPages);
         settotalCount(totalCount)
         toggleSkeletonLoader(false)
         dispatch(setUser({ ...userDetail, teams: optionsTeams, subscription }))
      } else {
         const { message } = resp
         toaster({ message, success })
      }
   }

   const handlePageChange = (event, pageNumber) => {
      setCurrentPage(pageNumber);
   };
 
   const editCaseButtonClickHandler = async (caseId) => {
      dispatch(isCaseSaved(false));
      const path = `/case/edit/${caseId}`;
      navigate(path, { state: { isCaseEditedMode: true } });
   }

   const onToggleDialog = (isDialogOpen) => {
      setIsModalOpen(isDialogOpen)
   }

   const onToggleDeleteCaseDialog = (isDialogOpen) => {
      setIsDeleteCaseModalOpen(isDialogOpen)
   }

   const openDeletCaseeModal = (Id) => {
      setCaseId(Id)
      setIsDeleteCaseModalOpen(true)
   }

   const deleteFreezedCase = async () => {
      try {
         const deletedCase = await deleteData(`${Constants.ApiUrl.deleteCase}/${caseId}`);
         console.log('Case deleted:', deletedCase);
         await getCases();
         setIsDeleteCaseModalOpen(false)
      } catch (error) {
         console.error('Error deleting case:', error);
         // Handle errors as needed
      }
   };

   const changeTypeOfDemandDraftHandler = (value) => {
      setTypeOfDemandDraft(value)
   }

   const handleSearchInputChange = (e) => {
      setsearchText(e.target.value)
   };

   const debouncedHandleSearchChange = debounce(handleSearchInputChange, 500);

   const handleClick = (event, id) => {
      setCurrentTarget(event.currentTarget)
      setAnchorEl(id);
   };

   const handleClose = () => {
      setAnchorEl(null);
   };

   const handleCopy = (id) => {
      navigator.clipboard.writeText(id).then(() => {
         toaster({ message: `${id} caseId Copied`, success: true })
      }).catch(err => console.error("Error copying text: ", err));
   };

   const downloadCaseInvoice = async ({ caseId, caseName }) => {

      try {
         const { success, data, message } = await postData(Constants.ApiUrl.downloadInvoice, { caseId });
         if (success) {
            try {
               const { wordUrl } = data;
               let link = document.createElement("a");
               link.download = `${caseName}-invoice.pdf`;
               link.href = wordUrl;
               link.click();
            } catch (e) {
               console.log("Error: ", e)
            }
         } else {
            toaster({ message, success });
         }
      } catch (e) {
         console.log("Error: ", e)
      }


   }

   return (
      <section className='content-wrapper'>
         <div className={`container layout-container case-list`}>
            <div className={`listing`}>
               <div className="row align-items-center">
              
                     <div className="col-md-3">
                        <span style={{ fontSize: '40px', color: 'black', fontFamily: 'Baskerville', fontWeight: 'bold' }}>
                           Cases
                        </span>
                     </div>
                  

                
                     <div className="col-md-9 d-flex">
                        <XMultiSelect
                           options={teams}
                           selectedValues={selectedTeamValues}
                           onChange={setSelectedTeamValues}
                           isForm={false}
                        />
                        <div className="position-relative" style={{ width: '40%' }}>

                           <input
                              onChange={debouncedHandleSearchChange}
                              type="search"
                              className="form-control"
                              placeholder="Search Cases"
                              aria-controls="myTable"
                              style={{
                                 height: '50px',
                                 color: '#292B2E',
                                 fontSize: '16px',
                                 borderRadius: '5px',
                                 paddingLeft: '10px'
                              }}
                           />
                           <i
                              className="fa-solid fa-magnifying-glass position-absolute"
                              style={{
                                 left: '90%',
                                 top: '50%',
                                 transform: 'translateY(-50%)',
                                 color: 'blue',
                                 background:"#fff"
                              }}
                           ></i>
                        </div>

                        {/* Add Case Button */}
                        <AddCaseButton/>
                     </div>
               

               </div>
               <div className="row mt-3">
                  <div className="d-flex justify-content-end">
                     <label className="form-check-label me-3" htmlFor="flexSwitchCheckDefault">Show Only My Cases?</label>
                     <label className="switch">
                        <input type="checkbox" checked={isMyCases} onChange={() => {
                           setIsMyCases(!isMyCases)
                           setCurrentPage(1)
                        }} />
                        <span className="slider"></span>
                     </label>
                  </div>
               </div>



               
                  <div id="myTable_wrapper" className="dataTables_wrapper no-footer mt-5">
                     {getCaseIsLoading && <div className='tableLoader'>
                        <XLoader />
                     </div>}
                     {/* Show Table List */}
                     {!getCaseIsLoading && <>
                        <TableContainer component={Paper} sx={{ boxShadow: "none", overflow: "unset" }}>
                           <Table>
                              <TableHead sx={{ backgroundColor: "#f8f9fc", }}>
                                 <TableRow>
                                    <TableCell sx={{ fontWeight: 600, padding: "10px 15px", width: '20%' }}>Title</TableCell>
                                    <TableCell sx={{ fontWeight: 600, padding: "10px 15px", width: '15%' }}>Updated On</TableCell>
                                    <TableCell sx={{ fontWeight: 600, padding: "10px 15px", width: "35%" }}>Status</TableCell>
                                    <TableCell sx={{ fontWeight: 600, padding: "10px 15px", width: "20%" }}>Download</TableCell>
                                    <TableCell sx={{ fontWeight: 600, padding: "10px 5px", width: "5%" }}>Edit</TableCell>
                                    <TableCell sx={{ fontWeight: 600, padding: "10px 5px", width: "5%" }}>MC</TableCell>
                                    <TableCell sx={{ fontWeight: 600, padding: "10px 5px", width: "5%" }}>Inv</TableCell>
                                 </TableRow>
                              </TableHead>
                              <TableBody>
                                 {items.map((x, index) => {
                                    const caseType = x?.caseInfo?.caseType ?? CASE_TYPE.AUTO_ACCIDENT;
                                    const excludedDemands = [DEMAND.Medical_Chronology];

                                    return (
                                       <TableRow key={index} >
                                          <TableCell aria-describedby={x._id} onClick={(event) => handleClick(event, x._id)}>
                                             <span style={{ borderBottom: x._id === anchorEl ? '2px solid black' : "" }}>
                                                {x?.caseInfo?.caseName}
                                             </span>
                                          </TableCell>
                                          <RenderIf shouldRender={anchorEl}>
                                             <Popover
                                                id={x._id}
                                                open={x._id === anchorEl}
                                                anchorEl={currentTarget}
                                                onClose={handleClose}
                                                anchorOrigin={{
                                                   vertical: 17,
                                                   horizontal: "left",
                                                }}
                                                transformOrigin={{
                                                   vertical: "bottom",
                                                   horizontal: "left",
                                                }}
                                                slotProps={{
                                                   paper: {
                                                      sx: {
                                                         boxShadow: "0px 9px 28px 8px rgba(0, 0, 0, 0.05), 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12)",
                                                      }
                                                   }
                                                }}
                                             >

                                                <Box className="case-popover">
                                                   <div className="d-flex align-items-center">
                                                      <span className="case-popover-Key">
                                                         Case ID: &nbsp;
                                                      </span>
                                                      <span className="case-popover-value">
                                                         <b>
                                                            {x?._id}&nbsp;
                                                         </b>
                                                      </span>
                                                      <CopyIcon style={{ cursor: "pointer" }} onClick={() => handleCopy(x._id)} />
                                                   </div>
                                                   <div className="d-flex align-center">
                                                      <span className="case-popover-Key">
                                                         Case Type: &nbsp;
                                                      </span>
                                                      <span className="case-popover-value">
                                                         {x?.caseInfo?.caseType}
                                                      </span>
                                                   </div>
                                                   <div className="d-flex align-center">
                                                      <span className="case-popover-Key">
                                                         Case Added: &nbsp;
                                                      </span>
                                                      <span className="case-popover-value">
                                                         {moment(x?.createdOn).format("YYYY-MM-DD HH:mm:ss")}
                                                      </span>
                                                   </div>
                                                   <div className="d-flex align-center">
                                                      <span className="case-popover-Key">
                                                         Latest Update: &nbsp;
                                                      </span>
                                                      <span className="case-popover-value">
                                                         {moment(x?.updatedOn).format("YYYY-MM-DD HH:mm:ss")}
                                                      </span>
                                                   </div>
                                                </Box>
                                             </Popover>
                                          </RenderIf>

                                          <TableCell>{ParseAndFormatUtcDateTime(x.updatedOn)}</TableCell>
                                          <TableCell>
                                             {x?.isDraftCase ?
                                                <Box>
                                                   This is a draft Case
                                                </Box>
                                                :
                                                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                   {x.isCaseGeneratedSccessfuly === false ? <CloseCircle /> : x.resultProgress.demandLetter_progress === "Successful" ? <TaskComplete style={{ color: 'green' }} /> : <div className="case-spinner">
                                                      <div className="case-spinner-dot"></div>
                                                      <div className="case-spinner-dot"></div>
                                                      <div className="case-spinner-dot"></div>
                                                      <div className="case-spinner-dot"></div>
                                                      <div className="case-spinner-dot"></div>
                                                      <div className="case-spinner-dot"></div>
                                                      <div className="case-spinner-dot"></div>
                                                      <div className="case-spinner-dot"></div>
                                                   </div>}


                                                   {x.resultProgress.demandLetter_progress === "Successful"
                                                      ? "100%"
                                                      : `${x?.resultProgress?.caseLoadingPercentage || 0}%`}
                                                   <LinearProgress
                                                      variant="determinate"
                                                      value={x.resultProgress.demandLetter_progress === "Successful"
                                                         ? 100
                                                         : (x?.resultProgress?.caseLoadingPercentage || 0)}
                                                      sx={{
                                                         height: 12,
                                                         width: "100%",
                                                         borderRadius: 5,
                                                         backgroundColor: "#ddd",
                                                         "& .MuiLinearProgress-bar": {
                                                            background: "radial-gradient(296.72% 130.97% at 60.31% -27.21%, #06F8E3 1.88%, #2C93E8 34.38%, #0A3381 100%)",
                                                         },
                                                         transition: "all 1s ease-in-out",
                                                      }}
                                                   />
                                                </Box>
                                             }
                                          </TableCell>

                                          <CaseActionControls
                                             caseData={x}
                                             caseType={caseType}
                                             excludedDemands={excludedDemands}
                                             editCaseButtonClickHandler={editCaseButtonClickHandler}
                                             downloadDemandDraft={downloadDemandDraft}
                                             downloadCaseInvoice={downloadCaseInvoice}
                                             openDeleteCaseModal={openDeletCaseeModal}
                                             changeTypeOfDemandDraftHandler={changeTypeOfDemandDraftHandler}
                                          />
                                       </TableRow>
                                    );
                                 })}
                              </TableBody>
                           </Table>
                        </TableContainer>
                        <div className="dataTables_info mt-4" id="myTable_info" role="status" aria-live="polite">Showing {currentPage === 1 ? 1 : (((currentPage - 1) * showEntries) + 1)} to {((currentPage - 1) * showEntries) + items.length} of {totalCount}</div>
                        <div className="dataTables_length mt-4" id="myTable_length" style={{ marginLeft: '40px' }}>
                           <label>
                              <select value={showEntries} onChange={(e) => setshowEntries(parseInt(e.target.value))} name="myTable_length" aria-controls="myTable" style={{ borderRadius: '15px' }}>
                                 <option value="10">10 per page</option>
                                 <option value="25">25 per page</option>
                                 <option value="50">50 per page</option>
                                 <option value="100">100 per page</option>
                              </select>
                           </label>
                        </div>


                        {totalPages > 1 && <div className="dataTables_paginate paging_simple_numbers mt-4" id="myTable_paginate">
                           <ReactPagination
                              activePage={currentPage}
                              totalItemCount={totalPages}
                              onChange={handlePageChange}
                           />
                        </div>}
                     </>}
                  </div>
               
               <Dialog
                  isModalOpen={isDeleteCaseModalOpen}
                  onToggleDialog={(isDialogOpen) => onToggleDeleteCaseDialog(isDialogOpen)}
                  mode="small-half"
                  isCloseIconHidden={false}
               >
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
                     <h3 className="title">Are you sure you want to proceed?</h3>
                     {/* <h4>{caseId}</h4> */}
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
                     <button className="btn btn-viewPdf1" style={{ width: '6rem', height: '3.5rem' }} onClick={() => deleteFreezedCase()}>Yes</button>
                     <button className="btn btn-viewPdf1" style={{ marginLeft: '1rem' }} onClick={() => setIsDeleteCaseModalOpen(false)}>No</button>
                  </div>
               </Dialog>

              

               <Dialog
                  isModalOpen={isModalOpen}
                  onToggleDialog={(isDialogOpen) => onToggleDialog(isDialogOpen)}
                  mode="full"
                  isCloseIconHidden={false}
               >
                  <h2 className="title">Error Log</h2>
                  <div style={{ overflow: 'scroll', height: '45rem' }}>
                     <table id="myTable" className="display dataTable no-footer" aria-describedby="myTable_info">
                        <thead >
                           <tr >
                              <th style={{ width: "200px" }}>ErrorId</th>
                              <th style={{ width: "200px" }}>CaseId</th>
                              <th style={{ width: "200px" }}>createdOn</th>
                              <th style={{ width: "200px" }}>Error Code</th>
                              <th style={{ width: "300px" }}>Error Description </th>

                           </tr>
                        </thead>
                        <tbody>
                           {
                              errorLogData?.map((values) => {
                                 return <tr>
                                    {/* userId, caseId, errorCode, errorDescrition, createDate */}
                                    <td>{values._id}</td>
                                    <td>{values.caseId}</td>
                                    <td>{values.createDate}</td>
                                    <td>{values.errorCode}</td>
                                    <td>{values.errorDescrition}</td>
                                 </tr>
                              })
                           }
                        </tbody>
                     </table>
                  </div>
               </Dialog >
              
            </ div >
         </div>
      </section>

   )

}


export default Cases
